import { useTranslation } from "react-i18next";import React from 'react';
import { cn } from '@/shared/utils';
import {
  FileText,
  Navigation,
  Thermometer,
  Play,
  TrendingUp,
  Shield } from
'lucide-react';

const StatCard = ({ icon: Icon, label, value, subtext, color, trend }) =>
<div className="bg-white rounded-xl border border-gray-200 p-4 hover:shadow-md transition-shadow">
    <div className="flex items-start justify-between">
      <div className={cn(
      "w-10 h-10 rounded-lg flex items-center justify-center",
      color === 'blue' && "bg-blue-50",
      color === 'emerald' && "bg-emerald-50",
      color === 'violet' && "bg-violet-50",
      color === 'amber' && "bg-amber-50",
      color === 'cyan' && "bg-cyan-50",
      color === 'red' && "bg-red-50"
    )}>
        <Icon className={cn(
        "h-5 w-5",
        color === 'blue' && "text-blue-600",
        color === 'emerald' && "text-emerald-600",
        color === 'violet' && "text-violet-600",
        color === 'amber' && "text-amber-600",
        color === 'cyan' && "text-cyan-600",
        color === 'red' && "text-red-600"
      )} />
      </div>
      
      {trend &&
    <div className={cn(
      "flex items-center gap-0.5 text-xs font-medium",
      trend > 0 ? "text-emerald-600" : "text-red-600"
    )}>
          <TrendingUp className={cn("h-3 w-3", trend < 0 && "rotate-180")} />
          <span>{Math.abs(trend)}%</span>
        </div>
    }
    </div>
    
    <div className="mt-3">
      <div className="text-2xl font-bold text-gray-900">{typeof value === 'number' ? value.toLocaleString() : value ?? 0}</div>
      <div className="text-sm text-gray-500 mt-0.5">{label}</div>
      {subtext &&
    <div className="text-xs text-gray-400 mt-1">{subtext}</div>
    }
    </div>
  </div>;


export const TrailStatsCard = ({ stats }) => {const { t } = useTranslation("ezparcel");
  if (!stats) return null;

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" data-testid="trail-stats">
      <StatCard
        icon={FileText}
        label="Total Events"
        value={stats.totalEvents ?? 0}
        color="blue"
        trend={5} />
      
      <StatCard
        icon={FileText}
        label="Audit Entries"
        value={stats.auditEntries ?? 0}
        color="violet" />
      
      <StatCard
        icon={Navigation}
        label="GPS Points"
        value={stats.gpsPoints ?? 0}
        color="emerald" />
      
      <StatCard
        icon={Thermometer}
        label="Temp Readings"
        value={stats.tempReadings ?? 0}
        color="cyan" />
      
      <StatCard
        icon={Play}
        label="Active Replays"
        value={stats.activeReplays ?? 0}
        color="amber" />
      
      <StatCard
        icon={Shield}
        label="Compliance"
        value={`${stats.complianceScore ?? 0}%`}
        color="emerald"
        subtext="All trails" />
      
    </div>);

};